var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C8.41015 3.5 5.5 6.41015 5.5 10C5.5 11.8872 6.27717 13.7425 7.35954 15.4021C8.43822 17.0559 9.78272 18.4581 10.8279 19.4237L10.828 19.4237C11.5025 20.0469 12.4975 20.0469 13.172 19.4237L13.1721 19.4237C14.2173 18.4581 15.5618 17.0559 16.6404 15.4021C17.7228 13.7425 18.5 11.8872 18.5 10C18.5 6.41015 15.5899 3.5 12 3.5ZM4 10C4 5.58173 7.58173 2 12 2C16.4183 2 20 5.58173 20 10C20 12.29 19.0635 14.4327 17.8968 16.2215C16.7264 18.016 15.2864 19.5125 14.1899 20.5255C12.9407 21.6797 11.0593 21.6797 9.81005 20.5255C8.71352 19.5125 7.27354 18.016 6.10315 16.2215C4.93646 14.4327 4 12.29 4 10ZM12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8ZM8.5 10C8.5 8.06701 10.067 6.5 12 6.5C13.933 6.5 15.5 8.06701 15.5 10C15.5 11.933 13.933 13.5 12 13.5C10.067 13.5 8.5 11.933 8.5 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.0cd2aa13a381ad07b6a4ddac00d4d2d2.svg";
export { ForwardRef as ReactComponent };